export default {
    "sso_error:access_denied":   "Authentication cancelled. Please try again and accept the requested permissions.",
    "sso_error:unallowed_email": "Your email address is not allowed to access this event.",
    "sso_error:unknown":         "Authentication error. Please try again.",
}
